
// Sample data for the Philadelphia marketing report — Berkshire Hathaway
// HomeServices Fox & Roach, Realtors. A DELAWARE RIVER waterfront listing near
// Philadelphia, PA. This file is fully self-contained. All values are
// illustrative samples.

/* --------------------------------- Brand ---------------------------------- */
// Berkshire Hathaway "Cabernet" + white. NO navy anywhere.
export const bhhs = {
  cab: '#6a1739',
  cabDeep: '#4f1029',
  cta: '#6a1739',
}

export const brokerage = {
  name: 'Berkshire Hathaway HomeServices Fox & Roach, Realtors',
  // Two-line cabernet lockup — for light backgrounds (header, footer, cards).
  logoLight:
    'https://cdn.magicpatterns.com/uploads/i5vB8tYEzNNwgYCyxYq9Fj/BHHS-FoxRoach-Logo_2Line-Cab.png',
  // One-line black lockup — alternate for dark/photo backgrounds where the
  // cabernet mark would not read (used on cabernet ad panels behind a white chip).
  logoBlack:
    'https://cdn.magicpatterns.com/uploads/s5xzaHgi6sWbNsuTJqjKG7/BHHS-FoxRoach-Logo_1Line_Black.png',
}

// Footer product attribution.
export const brand = {
  product: 'Virtual Results',
  tagline: 'Real Estate Advertising by Virtual Results',
  year: 2026,
  logoFull:
    'https://cdn.magicpatterns.com/uploads/bhU6Cy5Spft13hF8kqhr7p/vr_logo_cropped_text.png',
}

export const preparedDate = 'June 24, 2026'

// Device mockups showing the listing live online.
export const deviceMockups = {
  laptop:
    'https://cdn.magicpatterns.com/patterns/generated-images/31088a77-a3dd-4a33-8496-c704252a5c57.jpg',
  iphone:
    'https://cdn.magicpatterns.com/patterns/generated-images/ab78c99f-bd76-44c7-8058-7066d54d56da.jpg',
}

// Interior gallery thumbnails for the recreated Fox & Roach listing page shown
// in the "live on desktop" browser mockup.
export const interiorPhotos = [
  'https://cdn.magicpatterns.com/patterns/generated-images/7c4e9c57-aa71-41d7-9fe5-1413971cda2e.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/b14ef066-8dcc-40fe-99df-6cc0310d28af.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/ac5235e3-e5d9-47a9-8fb4-fc8d03790bbf.jpg',
]

/* -------------------------------- Listing --------------------------------- */
export const listing = {
  address: '1400 River Terrace',
  cityState: 'Philadelphia, Pennsylvania 19147',
  city: 'Philadelphia',
  price: '$3,850,000',
  beds: 5,
  baths: 6,
  sqft: '6,120',
  status: 'Active',
  daysLive: 28,
  reportPeriod: 'May 27 – Jun 24, 2026',
  heroImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/a3ade2cc-6181-4ae0-8a99-06484dea0518.jpg',
  // Along the Delaware River, Philadelphia PA (Queen Village / waterfront).
  lat: 39.9375,
  lng: -75.1414,
}

export const agent = {
  name: 'Meredith Callahan',
  title: 'Sales Associate',
  brokerage: brokerage.name,
  phone: '(215) 555-0182',
  email: 'mcallahan@foxroach.com',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/606d5f8e-037c-48c7-bcec-2c5e5f6ca09f.jpg',
}

/* ------------------------------ Headline stats ----------------------------- */
export const headlineStats = [
  {
    label: 'Total Impressions',
    value: '291,240',
    sub: 'Times your home was seen',
  },
  {
    label: 'Engaged Clicks',
    value: '7,015',
    sub: 'Buyers who took a closer look',
  },
  { label: 'Marketing Channels', value: '14', sub: 'Active across the web' },
  { label: 'Days on Market', value: '28', sub: 'Actively promoted' },
]

/* ------------------------- Campaign performance ---------------------------- */
export interface PerfStat {
  label: string
  value: string
  sub: string
}

export const perfStats: PerfStat[] = [
  {
    label: 'Impressions',
    value: '291,240',
    sub: "Times your home's ad was shown",
  },
  { label: 'Clicks', value: '7,015', sub: 'People who clicked to view' },
  {
    label: 'Marketing Channels',
    value: '14',
    sub: 'Active across the web',
  },
]

/* ------------------------------ Ad creatives ------------------------------- */
export interface AdCreative {
  id: string
  platform: 'Google' | 'Meta' | 'Instagram'
  placement: string
  shape: 'leaderboard' | 'rectangle' | 'square' | 'story'
  eyebrow: string
  headline: string
  body: string
  cta: string
  image: string
}

const HOME = listing.heroImage

export const adCreatives: AdCreative[] = [
  {
    id: 'google-leaderboard',
    platform: 'Google',
    placement: 'Leaderboard',
    shape: 'leaderboard',
    eyebrow: 'Waterfront · Philadelphia, PA',
    headline: 'Own the Philadelphia Riverfront',
    body: 'A rare 5-bed Delaware River estate with private dock, skyline views, and direct waterfront access. Offered at $3,850,000.',
    cta: 'Request a Private Showing',
    image: HOME,
  },
  {
    id: 'google-rectangle',
    platform: 'Google',
    placement: 'Medium Rectangle',
    shape: 'rectangle',
    eyebrow: 'New to Market',
    headline: 'Riverfront Living, Perfected',
    body: 'Sunrise over the Delaware from every room. Tour 1400 River Terrace.',
    cta: 'View the Estate',
    image: HOME,
  },
  {
    id: 'meta-square',
    platform: 'Meta',
    placement: 'Feed',
    shape: 'square',
    eyebrow: 'Just Listed',
    headline: 'Where the River Meets Home',
    body: 'An iconic Philadelphia waterfront estate — now available through Berkshire Hathaway HomeServices Fox & Roach.',
    cta: 'See the Listing',
    image: HOME,
  },
  {
    id: 'instagram-story',
    platform: 'Instagram',
    placement: 'Story',
    shape: 'story',
    eyebrow: 'Private Showings Open',
    headline: 'Your Riverfront Legacy Awaits',
    body: 'Tap to tour this $3.85M waterfront estate.',
    cta: 'Book a Showing',
    image: HOME,
  },
]

/* ----------------------- "Live on the web" placement ----------------------- */
export const featuredPlacement = {
  publisher: 'The Philadelphia Inquirer',
  publisherUrl: 'inquirer.com',
  category: 'Philadelphia News',
  siteImage: HOME,
  listingImage: HOME,
  adHeadline: 'Philadelphia Waterfront — $3,850,000',
  adBody: 'Private dock. Skyline views. Tour this landmark estate.',
  adCta: 'View Home',
}

/* --------------------------- Geographic reach ------------------------------ */
export interface ReachCluster {
  name: string
  lat: number
  lng: number
  intent: number
  radiusMiles: number
}

// Philadelphia + surrounding suburban buyer markets.
export const reachClusters: ReachCluster[] = [
  {
    name: 'Center City (home)',
    lat: 39.9375,
    lng: -75.1414,
    intent: 100,
    radiusMiles: 3,
  },
  {
    name: 'Main Line (Bryn Mawr)',
    lat: 40.0218,
    lng: -75.3157,
    intent: 84,
    radiusMiles: 5,
  },
  {
    name: 'Cherry Hill, NJ',
    lat: 39.9348,
    lng: -74.9597,
    intent: 68,
    radiusMiles: 4,
  },
  {
    name: 'Chestnut Hill',
    lat: 40.0743,
    lng: -75.2077,
    intent: 57,
    radiusMiles: 3,
  },
  {
    name: 'Wilmington, DE',
    lat: 39.7391,
    lng: -75.5398,
    intent: 46,
    radiusMiles: 5,
  },
  {
    name: 'Princeton, NJ',
    lat: 40.3573,
    lng: -74.6672,
    intent: 37,
    radiusMiles: 5,
  },
]

export const reachSummary = {
  primaryRadiusMiles: 30,
  note: 'Buyers across Greater Philadelphia — plus the Main Line, South Jersey, and nearby New York and D.C. markets — are the most likely to relocate to the Delaware riverfront. Brighter clusters show where interest is strongest.',
}

/* ------------------------ Premium publisher categories --------------------- */
export interface PublisherCategory {
  category: string
  impressions: string
  sites: string[]
}

export const publisherCategories: PublisherCategory[] = [
  {
    category: 'News',
    impressions: '51,240',
    sites: ['The Philadelphia Inquirer', 'PhillyVoice', 'The Daily Pennsylvanian'],
  },
  {
    category: 'Lifestyle',
    impressions: '42,880',
    sites: ['Philadelphia Magazine', 'Main Line Today', 'Grid'],
  },
  {
    category: 'Local & Community',
    impressions: '34,010',
    sites: ['Billy Penn', 'South Philly Review', 'Chestnut Hill Local'],
  },
  {
    category: 'Finance & Business',
    impressions: '22,460',
    sites: ['Philadelphia Business Journal', 'Wealth Coastal'],
  },
  {
    category: 'Travel & Leisure',
    impressions: '17,940',
    sites: ['Visit Philadelphia', 'Sail PA'],
  },
]

/* ----------------------------- Ad placements ------------------------------- */
export interface Placement {
  name: string
  featured: boolean
}

export const placements: Placement[] = [
  { name: 'BHHS.com', featured: true },
  { name: 'The Philadelphia Inquirer', featured: true },
  { name: 'The New York Times', featured: true },
  { name: 'Wall Street Journal Online', featured: true },
  { name: 'Zillow', featured: false },
  { name: 'Realtor.com', featured: false },
  { name: 'Google Advertising Network', featured: false },
]

export const placementsNote =
  '+ additional sites within the display network (dynamic list in future versions)'

/* ------------------------------- Syndication ------------------------------- */
export interface SyndicationLink {
  name: string
  status: 'Live' | 'Syndicated'
  url: string
}

export const syndicationLinks: SyndicationLink[] = [
  { name: 'BHHS.com', status: 'Live', url: 'https://www.bhhs.com' },
  { name: 'Zillow', status: 'Live', url: 'https://www.zillow.com' },
  { name: 'Realtor.com', status: 'Live', url: 'https://www.realtor.com' },
  { name: 'Redfin', status: 'Live', url: 'https://www.redfin.com' },
  { name: 'Homes.com', status: 'Live', url: 'https://www.homes.com' },
  { name: 'Trulia', status: 'Syndicated', url: 'https://www.trulia.com' },
  { name: 'Fox & Roach', status: 'Live', url: 'https://www.foxroach.com' },
  { name: 'WSJ Mansion', status: 'Syndicated', url: 'https://www.wsj.com' },
  {
    name: 'James Edition',
    status: 'Syndicated',
    url: 'https://www.jamesedition.com',
  },
  { name: 'MLS Network', status: 'Live', url: '#' },
  {
    name: 'Facebook Marketplace',
    status: 'Syndicated',
    url: 'https://www.facebook.com/marketplace',
  },
  { name: 'Local Broker Sites', status: 'Syndicated', url: '#' },
]

/* ------------------------------- Agent tools ------------------------------- */
export interface ToolItem {
  title: string
  description: string
  cta: string
  icon: 'ad' | 'social' | 'script' | 'email'
}

export const tools: ToolItem[] = [
  {
    title: 'Download ad creatives',
    description: 'High-res copies of every ad, ready to repost.',
    cta: 'Get creatives',
    icon: 'ad',
  },
  {
    title: 'Social media posts',
    description: 'Ready-to-publish posts for every platform.',
    cta: 'Open posts',
    icon: 'social',
  },
  {
    title: 'Copy-ready scripts',
    description: 'Captions and talking points that convert.',
    cta: 'View scripts',
    icon: 'script',
  },
  {
    title: 'Send an HTML email',
    description: 'Generate a branded email blast in one click.',
    cta: 'Build email',
    icon: 'email',
  },
]

/* ------------------------------- Footer note ------------------------------- */
export const footerNote =
  'Performance figures represent total campaign lifespan to date. "Example placement" illustrates ad format on representative publisher pages within the display network. Placement availability varies by campaign.'
